// Mirror of the Dr.-Hoffmann-related services configured on the shared
// backend (see `Tawan Spa/server/utils/massages.js`). Prices are in cents.

export const DR_HOFFMANN_SERVICES = [
  {
    key: "dr-hoffmann-wakeup-studio",
    label: "Wake-Up im Studio",
    category: "Dr. Hoffmann · Wake-Up",
    description:
      "5-Minuten Wake-Up Massage im Studio. 5 EUR online, 10 EUR bei Zahlung vor Ort.",
    durations: [{ minutes: 5, priceCents: 1000 }],
    requiresLogin: true,
    paymentDefault: "on-site",
    locationDefault: "Cremon 11, 20457 Hamburg",
  },
  {
    key: "dr-hoffmann-wakeup-onsite",
    label: "Wake-Up vor Ort",
    category: "Dr. Hoffmann · Wake-Up",
    description:
      "5-Minuten Wake-Up Massage vor Ort: 5 EUR online, 10 EUR bei Zahlung vor Ort. Anfahrt 39 EUR oder mit Gutschein 0 EUR.",
    durations: [{ minutes: 5, priceCents: 1000 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
  {
    key: "dr-hoffmann-wakeup-onsite-voucher",
    label: "Wake-Up vor Ort",
    category: "Dr. Hoffmann · Wake-Up",
    description:
      "Legacy-Service-Key für Wake-Up vor Ort mit Gutschein.",
    durations: [{ minutes: 5, priceCents: 1000 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
  {
    key: "dr-hoffmann-classic-studio",
    label: "Classic Massage im Studio",
    category: "Dr. Hoffmann Â· Studio",
    description:
      "10-Minuten Classic Massage im Studio. 29 EUR per Karte/online, 39 EUR vor Ort.",
    durations: [{ minutes: 10, priceCents: 3900 }],
    requiresLogin: true,
    paymentDefault: "on-site",
    locationDefault: "Cremon 11, 20457 Hamburg",
  },
  {
    key: "dr-hoffmann-classic-onsite",
    label: "Classic Massage vor Ort",
    category: "Dr. Hoffmann Â· Mobil",
    description:
      "10-Minuten Classic Massage vor Ort: 29 EUR per Karte/online oder 39 EUR vor Ort plus 39 EUR Anfahrt. Mit Gutschein entfaellt die Anfahrt.",
    durations: [{ minutes: 10, priceCents: 7800 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
  {
    key: "dr-hoffmann-premium-studio",
    label: "Intense Massage im Studio",
    category: "Dr. Hoffmann Â· Studio",
    description:
      "30- oder 60-Minuten Intense Massage im Studio. 70 EUR per Karte/online (30 Min.) bzw. 125 EUR (60 Min.), 80 EUR bzw. 150 EUR vor Ort.",
    durations: [
      { minutes: 60, priceCents: 12500 },
      { minutes: 30, priceCents: 8000 },
    ],
    requiresLogin: true,
    paymentDefault: "on-site",
    locationDefault: "Cremon 11, 20457 Hamburg",
  },
  {
    key: "dr-hoffmann-premium-onsite",
    label: "Intense Massage vor Ort",
    category: "Dr. Hoffmann Â· Mobil",
    description:
      "30- oder 60-Minuten Intense Massage vor Ort: 70 EUR per Karte/online (30 Min.) bzw. 125 EUR (60 Min.), 80 EUR bzw. 150 EUR vor Ort plus 39 EUR Anfahrt. Mit Gutschein entfaellt die Anfahrt.",
    durations: [
      { minutes: 60, priceCents: 18900 },
      { minutes: 30, priceCents: 11900 },
    ],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
  {
    key: "dr-hoffmann-business-event",
    label: "WM-Aktion",
    category: "Dr. Hoffmann · Event",
    description:
      "Platz an der WM-Aktion am 14.06.2026. Softdrinks und Essen inklusive.",
    durations: [{ minutes: 180, priceCents: 2900 }],
    requiresLogin: true,
    paymentDefault: "on-site",
    locationDefault: "Cremon 11, 20457 Hamburg",
  },
  {
    key: "dr-hoffmann-wakeup-plus-business",
    label: "Wake-Up+ für Unternehmen",
    category: "Dr. Hoffmann · Wake-Up",
    description:
      "Wake-Up Massage für Unternehmen. 1-10 Mitarbeitende 79 EUR netto zzgl. MwSt. inkl. Anfahrt, jede weitere Person plus 5 EUR.",
    durations: [{ minutes: 10, priceCents: 7900 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
  {
    key: "dr-hoffmann-consultation",
    label: "Lizenzpartner Erstbesuch",
    category: "Dr. Hoffmann · Lizenz",
    description:
      "Kostenloses Vor-Ort-Erstgespräch inkl. bis zu 6 Test-Massagen und Location-Check.",
    durations: [{ minutes: 30, priceCents: 0 }],
    requiresLogin: false,
    paymentDefault: "later",
    locationDefault: "Cremon 11, 20457 Hamburg",
  },
  {
    key: "dr-hoffmann-studio",
    label: "Dr. Hoffmann Massage im Studio",
    category: "Dr. Hoffmann · Studio",
    description:
      "10-Minuten Perkussiv-Massage im Studio am Cremon 11. Online oder vor Ort bezahlen.",
    durations: [
      { minutes: 10, priceCents: 2900 },
      { minutes: 15, priceCents: 2900 },
    ],
    requiresLogin: true,
    paymentDefault: "on-site",
    locationDefault: "Cremon 11, 20457 Hamburg",
  },
  {
    key: "dr-hoffmann-mobile",
    label: "Dr. Hoffmann Massage Vor Ort",
    category: "Dr. Hoffmann · Mobil",
    description:
      "10-Minuten Perkussiv-Massage bei Ihnen vor Ort (Büro, Event, Zuhause). Nur im Hamburger Stadtgebiet. Online oder vor Ort bezahlen.",
    durations: [{ minutes: 10, priceCents: 3900 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
  {
    key: "dr-hoffmann-hotel-15",
    label: "Dr. Hoffmann Massage im Hotel",
    category: "Dr. Hoffmann · Hotel",
    description: "15-Minuten Perkussiv-Massage für Hotelgäste.",
    durations: [{ minutes: 15, priceCents: 3900 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
  {
    key: "dr-hoffmann-hotel-60",
    label: "Personal Training & Mobility im Hotel",
    category: "Dr. Hoffmann · Hotel",
    description: "60-Minuten Training, Stretching und Regeneration für Hotelgäste.",
    durations: [{ minutes: 60, priceCents: 12500 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "on-site",
    locationDefault: null,
  },
];

export const LEONARDO_HOTEL_ADDRESS = {
  street: "Katharinenstraße 29",
  postalCode: "20457",
  city: "Hamburg",
};

export const LEONARDO_REGISTRATION_SOURCE = "leonardo-nikolai";

export const findService = (serviceKey, durationMinutes) => {
  const service = DR_HOFFMANN_SERVICES.find((s) => s.key === serviceKey);
  if (!service) return null;
  const duration = service.durations.find(
    (d) => Number(d.minutes) === Number(durationMinutes)
  );
  if (!duration) return null;
  return { service, duration };
};

export const formatPrice = (cents) =>
  (cents / 100).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });

export const isWakeupServiceKey = (serviceKey) =>
  [
    "dr-hoffmann-wakeup-studio",
    "dr-hoffmann-wakeup-onsite",
    "dr-hoffmann-wakeup-onsite-voucher",
  ].includes(String(serviceKey || ""));

export const individualServicePriceForPaymentMethod = (
  serviceKey,
  paymentMethod = "on-site",
  durationMinutes = 60
) => {
  const key = String(serviceKey || "");
  const online = paymentMethod === "stripe";
  const minutes = Number(durationMinutes) || 60;
  if (key === "dr-hoffmann-classic-studio" || key === "dr-hoffmann-classic-onsite") {
    return online ? 2900 : 3900;
  }
  if (key === "dr-hoffmann-premium-studio" || key === "dr-hoffmann-premium-onsite") {
    if (minutes === 30) {
      return online ? 7000 : 8000;
    }
    return online ? 12500 : 15000;
  }
  return null;
};

export const wakeupUnitPriceForPaymentMethod = (
  paymentMethod = "on-site",
  _user = null
) => (paymentMethod === "stripe" ? 500 : 1000);

export const priceForPaymentMethod = (
  baseCents,
  paymentMethod = "on-site",
  options = {}
) => {
  const serviceKey = options?.serviceKey;
  const fixedIndividualPrice = individualServicePriceForPaymentMethod(
    serviceKey,
    paymentMethod,
    options?.durationMinutes
  );
  if (fixedIndividualPrice != null) return fixedIndividualPrice;
  if (isWakeupServiceKey(serviceKey)) {
    return wakeupUnitPriceForPaymentMethod(paymentMethod, options?.user);
  }
  return baseCents;
};
